import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';

const callbackUuid = `id0${uuid().replace(/[^a-zA-Z]/g, '')}`;
export const useLoadGoogleMaps = (apiKey: string): boolean => {
  const [loaded, setLoaded] = useState<boolean>(!!window?.google?.maps);

  useEffect(() => {
    if (!window) {
      // no window defined
      return;
    }
    if (window?.google?.maps) {
      setLoaded(true);
      return;
    }
    if (document?.getElementById(callbackUuid)) {
      (window as any)[callbackUuid] = () => setLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.id = callbackUuid;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=${callbackUuid}`;
    script.async = true;
    (window as any)[callbackUuid] = () => {
      setLoaded(true);
    };
    document?.body.appendChild(script);
  }, [apiKey]);
  return loaded;
};
